module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_adjustment-9007e7099e746e7c997d2e17573644f9.png";